<script lang="ts">
	import { EditionsGalleryPage } from '#lib/websites/editions/pages/EditionsGalleryPage/index.js';
</script>

<EditionsGalleryPage />
